import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { KeyboardArrowDownOutlined } from "@mui/icons-material";
import { Typography } from "@mui/material";

import messages from "../../assets/locale/messages";
import {
  MyAccountIcon,
  SignOutIcon,
  UserAccountCircleIcon
} from "../../utils/Icons";
import { getDeviceId } from "../../utils/Auth";
import { logoutRequest } from "../../store/Auth/actions";
import { checkBackgroundImageValidity } from "../../utils/Helpers";
import Avatar from "../Avatar";
import MenuDropDown from "../Menu";
import "./UserDataDropDownBtn.scss";

const UserProfileButton = ({ className, contentClass }) => {
  const lang = useSelector((state) => state.locale.lang);
  const { shared } = messages[lang];
  const login = useSelector((state) => state.auth.login);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(
      logoutRequest({
        device_id: getDeviceId(),
        navigate
      })
    );
  };

  const [isProfileImageValid, setIsProfileImageValid] =
    useState(false);

  useEffect(() => {
    if (login.ProfileImage) {
      checkBackgroundImageValidity(login?.ProfileImage, (isValid) => {
        setIsProfileImageValid(isValid);
      });
    } else {
      setIsProfileImageValid(false);
    }
  }, [login]);

  return (
    <div
      className={`h-100 UserDataDropDown-button-wrapper d-flex justify-content-end  align-items-center p-md-2 border-radius-8 pointer ${className}`}>
      <MenuDropDown
        menuClass={"user-dropDown"}
        buttonClassName={
          "no-shadow user-drop-down-btn mx-lg-0  mx-md-1 px-2 px-md-4 py-1 py-md-2"
        }
        mainText={
          <>
            <div className={`admin-avatar pe-md-2`}>
              {isProfileImageValid ? (
                <Avatar
                  name={shared.profileImg}
                  imgSrc={login?.ProfileImage}
                  imgSrcAlt={shared.profileImg}
                  size={32}
                />
              ) : (
                <UserAccountCircleIcon className="account-circle" />
              )}
            </div>

            <div>
              <Typography
                className={`fsize-14 user-name d-none d-sm-block ${contentClass}`}
                sx={{ width: "max-content" }}>
                {`${shared.hi} ${login.FirstName}`}
              </Typography>
            </div>
            <KeyboardArrowDownOutlined />
          </>
        }
        menuList={[
          {
            label: shared.myAccount,
            icon: <MyAccountIcon />
            // onClick: handleGoToAccount
          },
          {
            label: shared.logout,
            icon: <SignOutIcon />,
            onClick: handleLogout
          }
        ]}></MenuDropDown>
    </div>
  );
};

UserProfileButton.propTypes = {
  className: PropTypes.string,
  labelClass: PropTypes.string,
  contentClass: PropTypes.string
};

export default UserProfileButton;
